<template>
  <div class="question-edit-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header class="top-title" v-if="!isWechatBrowser" title="发布问答" :showBack="true"></my-header>
    <div class="qa-title border-bottom-style">
      <input v-model="subject" maxlength="50" class="title-input" placeholder="请输入问题标题">
    </div>
    <div class="qa-detail">
      <textarea class="qa-detail-text" v-model="content"  rows="3" placeholder="请输入正文"></textarea>
    </div>
    <div class="record-img">
      <div class="image-area">
        <div class="image-view">
          <div v-if="attachmentUrlList.length>0" v-for="(recoredImg,index) in attachmentUrlList">
            <div class="image" :data-index="index" style="position: relative">
              <img @click="deleteImages(index)" style="width: 0.3rem;height: 0.3rem;position: absolute;right: -0.18rem;top: -0.18rem;" src="../../assets/icon/icon-image-del.png">
              <img :src="imgUrl+recoredImg" @click = "previewImg(imgUrl+recoredImg,attachmentUrlList)">
            </div>
          </div>
          <div>
            <div class="image add-image" @click.stop="addImage()">
              <span class="icon-plus"><img src="../../assets/icon/icon-question-upload.png"></span>
              <span style="display: none;"><input type="file" id="image-input" multiple accept="image/*"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="save-question-btn" @click="saveQuestion">发布</div>

    <div v-if="deleteImagesModal" class="tip-toast refuse-modal">
      <div class="refuse-modal-title">删除图片确认</div>
      <div class="refuse-modal-text">确定要删除该图片吗?删除后该图片将无法恢复!</div>
      <div class="confirm-footer" >
        <div class="cancel-btn" @click="cancelDelImages">取消</div>
        <div class="agree-btn" @click = "confirmDeleteImages">确定</div>
      </div>
    </div>
    <div v-if="deleteImagesModal" class="pay-box"></div>

    <div v-if="showTip" class="tip-toast refuse-modal">
      <div v-if="showWarmTip" class="refuse-modal-title">温馨提示</div>
      <div class="refuse-modal-text">{{showWarmTip ? '退出后将不保留此次编辑内容，是否仍要退出编辑?' : '退出此次编辑?'}} </div>
      <div class="confirm-footer" >
        <div class="cancel-btn" @click = "cancel()">取消</div>
        <div class="agree-btn" @click="leave()">退出</div>
      </div>
    </div>
    <div v-if="showTip" class="pay-box"></div>
  </div>
</template>

<script>
  import {Indicator,Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import questionService from '../../service/qa/QuestionService'
  import sensitiveWordsService from '../../service/qa/SensitiveWordsService'
  import userService from '../../service/customer/UserService'
  import baseService from '../../service/BaseService'
  import {imgUrl} from "../../config";

  export default {
    name: 'ArticleDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        questionId: '',
        imgUrl: imgUrl,
        subject:'',
        content:'',
        images:'',
        actions:[],
        showImage:'',
        showBig:false,
        sheetVisible:false,
        attachmentUrlList:[],
        isWechatBrowser:this.$verfyBrowserType(),
        deleteImagesModal:false,
        deleteImgIndex:0,
        qaSaved:false,
        showTip:false,
        showWarmTip:false,
        questionStatus:'1',
        sensitiveWordsList:[],
        userInfo: {},
        question: {},
      }
    },
    created(){
      this.questionId = this.$route.query.questionId || '';
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getSensitiveWords();
      if(this.questionId){
          this.getQuestionInfo(this.questionId)
      }
    },
    beforeRouteLeave(to, from, next) {
      if(from.name == 'QaEdit' && this.qaSaved){
        this.$destroy();
        next();
      }else if(from.name == 'QaEdit' && !this.subject && !this.content && !this.images && !this.qaSaved){
        this.showTip = true;
        this.showWarmTip = false;
        next(false);
      }else {
        this.showTip = true;
        this.showWarmTip = true;
        next(false);
      }
    },
    methods: {
      async saveQuestion(){
        this.getUserInfo();
        if(!this.subject){
          Toast('请输入问题标题');
          return false;
        }else if(this.subject.length>50){
          Toast('请输入50字以内问题标题');
          return false;
        }else if(this.subject.length<5){
          Toast('请输入大于5个字的问题标题');
          return false;
        }

        let isShowTip = false;
        if(this.userInfo.blacklistStatus == '1'){
            isShowTip = true;
            this.questionStatus = '2'
        }

        if(!isShowTip){
            for(let sensitive of this.sensitiveWordsList){
                if(this.subject.indexOf(sensitive.words) != -1){
                    isShowTip = true;
                    this.questionStatus = '2'
                }
                if(this.content.indexOf(sensitive.words) != -1){
                    isShowTip = true;
                    this.questionStatus = '2'
                }
            }
        }
        if(this.images.substring(0,1) == ','){
          this.images = this.images.substring(1,this.images.length);
        }
        let question = {id:this.questionId, subject:this.subject,content:this.content,images:this.images,status:this.questionStatus};
        let {code,msg,data} = await questionService.save(question);
        if(code == '0'){
          this.qaSaved = true;
          if(isShowTip){
              Toast('发文成功，但本文可能含有不当内容，需经审核方可发表。')
          } else {
              Toast('发布问题成功!');
          }
          this.$router.go(-1);
        }else {
          Toast(msg);
        }
      },
      async getSensitiveWords(){
          let {code,msg,data} = await sensitiveWordsService.list();
          if(code == '0'){
              this.sensitiveWordsList = data;
          }else {
              Toast(msg);
          }
      },
      async getUserInfo(){
          let {code,msg,data} = await userService.getUserInfo();
          if(code == '0'){
              this.userInfo = data;
          }else {
              Toast(msg);
          }
      },
      async getQuestionInfo(id){
          let {code,msg,data} = await questionService.detail(id);
          if(code == '0'){
              console.info(data);
              this.subject = data.subject;
              this.content = data.content;
              this.images = data.images;
              this.attachmentUrlList = [];
              this.previewImageList = [];
              if(this.images){
                  let showImageArray = this.images.split(',');
                  for (let image of showImageArray){
                      this.attachmentUrlList.push(image)
                  }
              }else {
                  this.attachmentUrlList = [];
              }
          }else {
              Toast(msg);
          }
      },
      async addImage(){
        var sUserAgent=navigator.userAgent;
        if(sUserAgent.endsWith("jikeWeb")){
          this.actions = [{
            name: '拍照',
            method: this.openCamera
          }, {
            name: '从相册中选择',
            method: this.selectImage
          }];
          this.sheetVisible = true;
        }else{
          //使用input文件选择
          var fileInput = document.querySelector("#image-input");
          fileInput.click();
          var that = this;
          fileInput.onchange = function(){
            for(let file of this.files){
              let fileSize = file.size;
              if(fileSize > 0 && Math.round(fileSize/1024/1024*100)/100 < 20){
                Indicator.open({
                  text: '加载中...',
                  spinnerType: 'fading-circle'
                });
                lrz(file,{width: 1024,fieldName:'imgFile',quality:0.6}).then((rst) =>{
                  return baseService.uploadImage(file);
                }).then((file) => {
                  that.images = that.images + ',' +file.name;
                  that.attachmentUrlList.push(file.name)
                }).catch((err) =>{
                  console.log("上传文件失败========",err);
                }).always(()=>{
                  Indicator.close();
                });
              }else {
                Toast('请上传小于20M的图片!');
              }
            }
          }
        }
      },
      cancel(){
        this.showTip = false;
        this.showWarmTip = false;
      },
      leave(){
        this.$destroy();
        this.$router.go(-1);
      },
      previewImg(currentImage,imageList){
        let previewImageList = [];
        for (let image of imageList){
          let previewImage = this.imgUrl + image;
          previewImageList.push(previewImage);
        }
        wx.previewImage({
          current: currentImage, // 当前显示图片的http链接
          urls: previewImageList // 需要预览的图片http链接列表

        });
      },
      deleteImages(index){
        this.deleteImgIndex = index;
        this.deleteImagesModal = true;
      },
      cancelDelImages(){
        this.deleteImgIndex = 0;
        this.deleteImagesModal = false;
      },
      confirmDeleteImages(){
        var that= this;
        let images = that.attachmentUrlList + '';
        let removeStr = that.attachmentUrlList[this.deleteImgIndex];
        var recordImagesStr = '';
        var recordImagesArry  = images.split(",");
        for(var i=0; i<recordImagesArry.length; i++) {
          if(recordImagesArry[i] == removeStr) {
            recordImagesArry.splice(i, 1);
          }
        }
        if(recordImagesArry!=null) {
          for (var i = 0; i < recordImagesArry.length; i++) {
            recordImagesStr = recordImagesStr + ',' + recordImagesArry[i];
          }
          that.images = recordImagesStr.substring(1, recordImagesStr.length);
        }
        that.attachmentUrlList = recordImagesArry;
        that.deleteImgIndex = 0;
        that.deleteImagesModal = false;
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .question-edit-page {
    height: 100vh;
    background:white;
    font-size: 0.28rem;
    text-align: left;
    .tip-toast{
      background-color: white;
      width: 6rem;
      position: fixed;
      z-index: 1000;
      color: white;
      text-align: center;
      border-top-left-radius: 0.1rem;
      border-top-right-radius: 0.1rem;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
     .pay-box{
      overflow: hidden;
      position:fixed;
      top:0;
      bottom:0;
      left:0;
      right:0;
      background-color: rgba(0, 0, 0,0.4);
      z-index: 1001
    }
    .refuse-modal{
      width: 6rem;
      text-align: left;
      background-color: white;
      z-index: 1002;
      .refuse-modal-title{
        border-top-left-radius: 0.1rem;
        border-top-right-radius: 0.1rem;
        background-color: #feac00;
        color: white;
        font-weight: 600;
        padding-left: 0.4rem;font-size: 0.32rem;line-height: 0.9rem
      }
      .refuse-modal-text{
        padding-left: 0.4rem;
        padding-top: 0.4rem;
        padding-bottom: 0.58rem;
        font-size: 0.28rem;
        color: #878e99;
      }
      .confirm-footer{
        width: 3.88rem;
        margin: 0 auto;
        font-size: 0.28rem;
        padding-bottom: 0.4rem;
        display: flex;
        justify-content: space-between;
        .agree-btn{
          background-color: #feac00;
          border-radius: 0.3rem;
          text-align: center;
          width: 1.7rem;
          height: 0.62rem;
          line-height: 0.7rem;
          color: white;
        }
        .cancel-btn{
          border-radius: 0.3rem;
          border: solid 1px #d5dee2;
          width: 1.7rem;
          height: 0.62rem;
          line-height: 0.7rem;
          text-align: center;
          color: #1b1e29
        }
      }
    }
    .save-qa-btn{
      position: fixed;
      right:0;
      top: 0.2rem;
      z-index: 900;
      padding: 0.2rem 0.3rem
    }
    .default-save-btn-color{
      color: white;
    }
    .save-btn-color{
      color: #feac00;
    }
    .qa-title{
      width: 6.9rem;
      background: white;
      margin-left: 0.3rem;
      .title-input{
        height: 0.98rem;
        line-height: 1rem;
        font-size: 0.36rem;
        width: 6.9rem;
        color: #7f7d7c;
        font-weight: bold;
      }
      *::-webkit-input-placeholder { /* WebKit browsers*/
        color:#7f7d7c!important;
        font-size:0.36rem!important;
        padding-top:0.02rem;
      }
      *:-moz-placeholder {  /* Mozilla Firefox 4 to 18*/
        color:#7f7d7c!important;
        font-size:0.36rem!important;
        padding-top:0.02rem;
      }
      *::-moz-placeholder {  /* Mozilla Firefox 19+*/
        color:#7f7d7c!important;
        font-size:0.36rem!important;
        padding-top:0.02rem;
      }
      *:-ms-input-placeholder { /* Internet Explorer 10+*/
        color:#7f7d7c!important;
        font-size:0.36rem!important;
        padding-top:0.02rem;
      }
    }
    .qa-detail{
      background: white;
      padding: 0.3rem 0.3rem 0 0.3rem;
      .qa-detail-text{
        font-family: NotoSansHans-Regular;
        width: 100%;
        font-size: 0.32rem;
        resize:none
      }
    }
    .image-area{
      background-color: #fff;
      width: 100%;
      .image-view{
        display: flex;
        flex-flow: row wrap;
        padding:0 14px 0.3rem;
        padding-right:0px;
        .image{
          width: 2.2rem;
          height: 2.2rem;
          border-radius: 0.1rem;
          margin-bottom: 5px;
          margin-right: 0.15rem;
          &.add-image{
             display: flex;
             flex-flow: row wrap;
             justify-content: center;
             align-items: center;
             color: #999;
             border-radius: 0.1rem;
           }
          .icon-plus img{
            width: 2.2rem;
            height: 2.2rem;
            position: relative;
            margin-left: 0.3rem;
          }
          img{
            width: 100%;
            height: 100%;
            border-radius: 0.1rem;
          }
        }
      }
      .image-tip{
        padding:10px;
        font-size: 14px;
        color: #999999;
      }
    }
    .delete-images-box{
      overflow: hidden;
      position:fixed;
      top:0;
      bottom:0;
      left:0;
      right:0;
      background-color: rgba(0, 0, 0,0.4);
      z-index: 100
    }
    .save-question-btn{
      width: 2.8rem;
      color: white;
      font-size: 0.36rem;
      font-family: NotoSansHans-Medium;
      line-height: 0.8rem;
      text-align: center;
      border-radius: 0.4rem;
      background-color: #feac00;
      margin: 5.5rem auto 0rem auto;
      letter-spacing: 0.1rem;
    }
  }
</style>
